import React, { useEffect, useState } from "react";
import { loginReport, useUserInfo } from "./store";
import { getCurrentUserRole } from "modules/utilities/utility";
import PaginationComponent from "./PaginationComponent";

function LoginReport() {
  const { fetchUserData, userData } = useUserInfo();
  const currentUser = getCurrentUserRole();
  const { loginReportResult, getLoginReport } = loginReport();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  // const [isCollapsed, toggleCollapse] = useState(true);
  const [expandedSections, setExpandedSections] = useState([]);
  const itemsPerPage = 10; // Set the number of items per page

  useEffect(() => {
    fetchUserData(currentUser);
  }, [currentUser]);

  useEffect(() => {
    getLoginReport(startDate, endDate);
  }, [startDate, endDate]);

  // Function to find user's first_name based on user_id
  const findFirstName = (userId) => {
    const user = userData.find((user) => user.user.id === userId);
    return user ? user.user.first_name : "Unknown";
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = loginReportResult.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const toggleSection = (index) => {
    const updatedSections = [...expandedSections];
    updatedSections[index] = !expandedSections[index];
    setExpandedSections(updatedSections);
  };

  const renderSessionDetails = (sessions, index) => {
    if (!sessions || sessions.length === 0) {
      return <div>No sessions available</div>;
    }

    // Filter out the latest session
    const latestSession = sessions[0];
    const otherSessions = sessions.slice(1);

    return (
      <div>
        <div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>
                  <button
                    onClick={() => toggleSection(index)}
                    className="btn btn-info"
                    style={{ padding: "2px 6px" }}
                  >
                    +
                  </button>
                </th>
                <th>Session ID</th>
                <th>Login Time</th>
                <th>Logout Time</th>
                <th>IP Address</th>
                <th>Is Mobile</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{findFirstName(latestSession?.user_id)}</td>
                <td>{latestSession?.session_id}</td>
                <td>{latestSession?.loginTime}</td>
                <td>{latestSession?.logoutTime}</td>
                <td>{latestSession?.ipAddress}</td>
                <td>{latestSession?.isMobile ? "true" : "false"}</td>
                <td>
                  {latestSession?.duration}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {expandedSections[index] && (
          <div>
            <strong>Other Sessions:</strong>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Session ID</th>
                  <th>Login Time</th>
                  <th>Logout Time</th>
                  <th>IP Address</th>
                  <th>Is Mobile</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                {otherSessions.map((session, index) => (
                  <tr key={index}>
                    <td>{session?.session_id}</td>
                    <td>{session?.loginTime}</td>
                    <td>{session?.logoutTime}</td>
                    <td>{session?.ipAddress}</td>
                    <td>{session?.isMobile?.toString()}</td>
                    <td>{latestSession?.duration}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const pageNumbers = Math.ceil(loginReportResult.length / itemsPerPage);

  return (
    <div>
      <h2>Login Report</h2>
      {currentItems.map((user, index) => (
        <div key={index}>
          {renderSessionDetails(user.documents, index)}
          <hr />
        </div>
      ))}
      <PaginationComponent
        currentPage={currentPage}
        totalPages={pageNumbers}
        handlePageChange={handlePageChange}
        pagesToShow={5}
      />
    </div>
  );
}

export default LoginReport;